import { render, staticRenderFns } from "./BillsPage.vue?vue&type=template&id=726e65ae&scoped=true&lang=html&"
import script from "./BillsPage.vue?vue&type=script&lang=js&"
export * from "./BillsPage.vue?vue&type=script&lang=js&"
import style0 from "./BillsPage.vue?vue&type=style&index=0&id=726e65ae&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726e65ae",
  null
  
)

export default component.exports